import { format, parseISO } from 'date-fns'

import { PrazoEntregaSimulacao } from '@/domain/simulador/prazo-entrega-simulacao'
import type { TExtratorDeDatas } from '@/features/simulador/shared/domain/extratores-de-datas'
import { getDatasParcelas } from '@/features/simulador/shared/domain/get-datas-parcelas'
import { PrazoPagamentoSimulacao } from '@/features/simulador/shared/domain/prazo-pagamento-simulacao'
import { maxDate } from '@/utils/date.utils'

export type TGruposPrazoBase = {
  dataSimulacao: string
  dataPrevisaoDeEntregaDoBloco: string
}

export class CalculadorPrazoBase<T extends TGruposPrazoBase> {
  constructor(
    protected readonly grupos: T,
    protected readonly extratores: Array<TExtratorDeDatas<T>>,
  ) {}

  protected getDatasParcelas(): string[] {
    return getDatasParcelas(this.grupos, this.extratores)
  }

  calcular() {
    const { prazoEntregaEmMeses, isEmpreendimentoEntregue } = this.calcularPrazoEntrega()

    const dataSimulacao = this.grupos.dataSimulacao

    const datasParcelas = this.getDatasParcelas().map((data) => parseISO(data))
    const dataUltimaParcelaComPosConclusao = format(maxDate(datasParcelas), 'yyyy-MM-dd')

    const { prazoPagamentoEmMeses } = new PrazoPagamentoSimulacao(dataSimulacao, dataUltimaParcelaComPosConclusao)

    return { prazoPagamentoEmMeses, prazoEntregaEmMeses, isEmpreendimentoEntregue }
  }

  calcularPrazoEntrega(): PrazoEntregaSimulacao {
    return new PrazoEntregaSimulacao(this.grupos.dataSimulacao, this.grupos.dataPrevisaoDeEntregaDoBloco)
  }
}
